export default {
  Studies: "Estudos",
  Layouts: "Layouts",
  Sync: "Sincronização",
  scroll: "Rolar",
  wwwc: "Níveis",
  zoom: "Zoom",
  general: "Geral",
  zooming: "Zoom",
  annotation: "Medições",
  rotating: "Rotações",
  Pan: "Mover",
  Wwwc: "Níveis por ponto",
  WwwcRegion: "Níveis por polígono",
  Magnify: "Lupa",
  Zoom: "Zoom",
  Screen: "Captura de tela",
  Rotate: "Girar",
  Flip: "Espelhar",
  Reset: "Redefinir",
  Eraser: "Borracha",
  ArrowAnnotate: "A - Anotação",
  Bidirectional: "Cruz",
  Angle: "Ângulo",
  EllipticalROI: "E - Elipse",
  FreehandRoi: "Linha livre",
  Length: "L - Régua",
  Probe: "Marcador de ponto",
  RectangleRoi: "Retângulo",
  TextMarker: "Marcadores de texto",
  DragProbe: "Sonda",
  ScaleOverlay: "Escalas",
  OrientationMarkers: "Marcadores de orientação",
  Brush: "Trajeto livre",
  CircleScissors: "Elipse",
  FreehandScissors: "Forma livre",
  RectangleScissors: "Retângulo",
  Invert: "Inverter",
  Clip: "Rolagem automática",
  Series: "Séries",
  Report: "Relatório",
  patientId: "ID do paciente",
  fullname: "Nome completo",
  birthday: "Data de nascimento",
  studyCreatedAt: "Data do estudo",
  old: "Idade",
  patientSex: "Sexo",
  "Result AI": "Resultado da análise por IA",
  "Download dicom": "Baixar séries de IA",
  "Download report": "Baixar relatório",
  Loading: "Carregando",
  Cached: "em cache",
  male: "Masculino",
  female: "Feminino",
  Copy: "Copiar",
  "Copy ok": "Copiado",
  "Copy error": "Não foi possível copiar o texto",
  Anonymized: "Anonimizado",
  StackScroll: "Rolagem",
  "Result after upload message":
    "Relatório estará disponível após análise do estudo",
  "Result ai error message": "Não foi possível processar o estudo, tente outro",
  error: "Erro",
  "dcm cannot loading": "Não foi possível carregar arquivos .dcm",
  "error read dcm": "Erro ao ler o estudo",
  ai: "Estudo com IA",
  original: "Estudo original",
  "How to use title": "Guia de uso do serviço",
  "How to use": "Instruções",
  "ai accept caption": "O resultado da análise por IA está correto?",
  "thx for feedback": "Obrigado pelo feedback!",
  SelectedAccept: { 1: "Você marcou que o resultado", 2: "da IA" },
  "accept yes": "está correto",
  "accept no": "está incorreto",
  "View title": "Estudo | " + process.env.VUE_APP_INSTALL_NAME,
  Share: "Compartilhar",
  "Share done": "Feito",
  "Share about": "Link copiado para a área de transferência",
  "Cancel preset": "Redefinir",
  Description: "Descrição",
  "About study": "Sua resposta",
  CheckReport: "Enviar",
  "Your description": "Sua resposta",
  "Best description": "Descrição de referência",
  "Teacher comment": "Comentário do instrutor",
  "Answer exist": "Concluído",
  "Answer not exist": "Sem resposta",
  from: "de",
  "Skip all": "Pular tudo",
  "Add screenshot": "Fazer captura de tela",
  "About screen info":
    "Você pode fazer anotações e anexar capturas de tela do visualizador (à esquerda), clicando no botão 'Fazer captura de tela'. Ou envie do seu computador clicando no clipe.",
  "Screenshot doned": "Feito",
  PlanarFreehandROI: "R - Contorno",
  MPR: "MPR",
  "Disable MPR First": "Desative o modo MPR",
  Crosshairs: "MIP e eixos",
  "MPR: only for 2+": "MPR indisponível",
  "MPR: hpu tier == 0":
    "Seu dispositivo não é potente o suficiente para reconstruções",
  "MPR: modality not support":
    "MPR não é suportado para a modalidade <modality>",
  "Cannot loading screen -- adblock":
    "Não foi possível carregar captura de tela. Desative extensões como VPN ou bloqueadores de anúncios",
  "Cannot loading screen -- s3 request":
    "Não foi possível carregar a captura de tela. Tente novamente mais tarde ou entre em contato com o suporte",
  "Cannot loading screen -- upload":
    "Erro no upload da captura de tela. Tente novamente mais tarde ou contate o suporte",
  voi: "Brilho",
  camera: "Pan/zoom",
  "Remove?": "Remover?",
  Support: "Suporte",
  "Support info": "Você pode fazer uma pergunta ou relatar um problema",
  "Send work?": "Finalizar descrição e enviar para revisão?",
  shareAIResult:
    "Veja como a IA analisou o estudo na Plataforma “" +
    process.env.VUE_APP_INSTALL_NAME +
    "”:",
  "Edit study": "Editar resposta",
};
